{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "title": "ImageText",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "heading",
    "highlight",
    "html",
    "imagePosition"
  ],
  "properties": {
    "heading": {
      "title": "Heading",
      "type": "string",
      "maxLength": 120
    },
    "highlight": {
      "title": "Highlighted heading part",
      "type": "string",
      "maxLength": 120
    },
    "html": {
      "title": "Text",
      "type": "string",
      "maxLength": 8000,
      "x-ui": "richtext"
    },
    "imageMediaId": {
      "title": "Image",
      "type": [
        "string",
        "null"
      ],
      "pattern": "^[0-9a-fA-F-]{36}$",
      "x-ui": "media"
    },
    "imagePosition": {
      "title": "Image position",
      "enum": [
        "right",
        "left"
      ],
      "x-ui": "select"
    }
  }
}
